import { render, staticRenderFns } from "./GlobalSavings.vue?vue&type=template&id=281aa18f"
import script from "./GlobalSavings.vue?vue&type=script&lang=js"
export * from "./GlobalSavings.vue?vue&type=script&lang=js"
import style0 from "./GlobalSavings.vue?vue&type=style&index=0&id=281aa18f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports